import * as React from 'react';
import classnames from 'classnames';

import { __t } from 'utils/language';

import './add-zalando-brand-form.scss';

import type { Notification } from '../../types/Notification.type';

type Props = {
  notification: Notification,
  onHide: () => void
};

const getNotificationText = (notification: Notification): string => {
  if (notification.type === 'none') {
    return '';
  }

  if (notification.type === 'error') {
    if (notification.source === 'server') {
      return __t('add_zalando_brand_form.error_message_server');
    }

    return __t('add_zalando_brand_form.error_message_user_input');
  }

  return __t('add_zalando_brand_form.success_message');
};

const AddZalandoBrandFormNotification = ({
  notification,
  onHide
}: Props) => {
  React.useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (notification.type !== 'success') {
        onHide();
      }
    }, 5000);

    return () => clearTimeout(timeoutId);
  });

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <React.Fragment>
      {notification.type !== 'none' && (
        <span
          className={classnames({
            'add-zalando-brand-form__outcome': true,
            [`add-zalando-brand-form__outcome--${notification.type}`]: true
          })}
        >
          {getNotificationText(notification)}
        </span>
      )}
    </React.Fragment>
  );
};

export default AddZalandoBrandFormNotification;
